import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserItemProps } from "apis";
import { GroupUserItemProps } from "apis/group-user";
import { PaginationProps } from "utils/types/API";

export interface GroupUserState {
    loading: boolean;
    list: {
        data: GroupUserItemProps[];
        options: GroupUserItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: GroupUserItemProps;
        users?: UserItemProps[]
    };
}

const initialState: GroupUserState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: GroupUserItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: GroupUserItemProps;
}
export const groupUserSlice = createSlice({
    name: "groupUser",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        findUser: (state, action: PayloadAction<{ data: UserItemProps[] }>) => {
            state.loading = false;
            state.item.users = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update, findUser } = groupUserSlice.actions;
export default groupUserSlice.reducer;
